import './src/main.css'
import ScrollBoard from './src/main.vue'

export default function (Vue) {
  Vue.component(ScrollBoard.name, ScrollBoard)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/scrollBoard/index.js